import React, {Component} from 'react'
import {
    NavBar,
    Icon,
    List,
    WhiteSpace,
    InputItem,
    Button,
    WingBlank,
    TextareaItem,
    Toast,
  } from "antd-mobile";
import { extend } from 'lodash';
import axios from "../../../service/axios";
import NoneDatas from "../../../components/noneDatas";
import './groupPrefixDetails.scss'
const Item = List.Item;
const Brief = Item.Brief;

export class GroupPrefixDetails extends Component {
  state = {
    lists:[]

  }
  componentWillMount(){
    this.selectGroupPrefixDetails(this.props.location.search.split('?')[1])
  }

  // 查询前缀群组详情
  selectGroupPrefixDetails(prefixName){
    axios.post('api/group/prefixname/list/detail',{prefixName})
    .then(res => {
      if(res && res.status === 200){
        console.log(res)
        this.setState({lists: res.data})
      }
    })
  }

  render(){
    const {
      lists
    } = this.state
    return(
      <div className='GroupPrefixDetails'>
        <div className='header-sticky'>
          <NavBar
            icon={<Icon type="left" />}
                onLeftClick={() => this.props.history.goBack()}
            >
              前缀列表详情
          </NavBar>
        </div>
        <div className='groupPrefixList' style={{paddingTop: '45px'}}>
          {lists.length == 0 ? <NoneDatas/>:null}
            {lists.map((item,index)=> {
              return (
                <div key={index}>
                  <List>
                    <Item
                      key={index}
                      // arrow="horizontal"
                      // onClick={() => {
                      //   this.showActionSheet(item)
                      //   // 调取微信扫码
                      //   // this.DYcamera(item.prefixName)
                      //   // 判断扫描结果的iccid在平台有绑定账号
                      //   // this.checkIccid(`/prefixInfo/${item.prefixName}/${getICCID}`)
                        
                      // }}
                    >
                      {item.name}
                    </Item>
                </List>
                </div>
              )
            })}
            <WhiteSpace />
        </div>
      </div>
    )
  }
}

export default GroupPrefixDetails